function Logo() {
  return (
    <img src="/images/shippersedge-logo.png" alt="Shippers Edge logo" className="logo medium" />
  )
}

export default Logo
